<!-- `gap-2px` keeps the hint tight under the title, so the pair reads as one block and the
     card's own gap is what separates it from the content below. `dfc-jcc` is the existing
     split row - title hard left, action hard right. -->
<div class="d-flex flex-column gap-2px">
    <div class="dfc-jcc">
        <h6 class="form-section__title">
            @if (to.icon) { <img [src]="to.icon" class="icons" alt="" /> }
            {{ to.label }}
        </h6>

        @if (to.linkText) {
            <span class="form-link-and-text">
                <span class="ds-text-link" (click)="onLinkClick()">{{ to.linkText }}</span>
                <!-- <img [src]="ICONS.CHEVRON_RIGHT" class="icons" alt="" /> -->
            </span>
        }
    </div>

    @if (to.hint) {
        <p class="form-section__hint">{{ to.hint }}</p>
    }
</div>
